module.exports = __webpack_public_path__ + "img/2.efa47ef1.jpg";